<style>
  .heading1{
        text-align: center;
    }
    .card{
      cursor: pointer;
    }
    .card-margin{
      margin:1em 0em;
    }
    .snippets-tags-grid{
      display:grid;
      grid-template-columns: 65% 35%;
    }
    /* Tag card does not exist inthis html */
    .tag-card{
      margin:1em 1em 1em 0em;
    }
    .mat-card-snippet{
       width: 80%;
       margin: auto;
       margin-top: 16px;

    }
    @media only screen and (max-width: 799px) {
      .tag-card{
        display:none;
      }
      .snippets-tags-grid{
        grid-template-columns: 1fr;
      }
    }
    @media only screen and (max-width: 799px) {
      .mat-card-snippet{
        width: 90%;
      }
    }
</style>


<div class="snippets-tags-grid" style="margin:1em;">
  <div class="card card-margin">
    <mat-card class="mat-card-snippet" *ngFor="let item of snippets">
      <a [routerLink]="['/snippets', item.route]">
      <mat-card-header>
        <mat-card-title>{{ item.title }}</mat-card-title>
        <mat-card-subtitle>{{ item.sub_title }}</mat-card-subtitle>
      </mat-card-header>
      </a>
      <mat-card-actions style="padding: 0px 16px; display: flex; flex-wrap: wrap;">
        <a *ngFor="let tag of item.tags" [routerLink] ="['/snippets/tags']" [queryParams] ="{ tag: tag.name }">
          <span class="tag" [class]= "tag.classexpression">#{{ tag.name }}</span>
        </a>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
